export const SALE_RECEIPT_LIST_REQUEST = "SALE_RECEIPT_LIST_REQUEST"; 
export const SALE_RECEIPT_LIST_SUCCESS = "SALE_RECEIPT_LIST_REQUEST_SUCCESS";
export const SALE_RECEIPT_DETAIL_REQUEST = "SALE_RECEIPT_DETAIL_REQUEST"; 
export const READ_SALE_RECEIPT = 247000;
export const PRINT_SALE_RECEIPT = 247007;